module.exports = __webpack_public_path__ + "img/background.36aa3311.jpg";